import React from 'react';
import { GlobalHotKeys, HotKeys } from 'react-hotkeys';
import { displayPiecesListAction } from 'containers/Configurator/actions/general';
import { useDispatch } from 'react-redux';
import keyMap, { globalKeyMap } from 'containers/Configurator/keymap';
import {
  historyRedoAction,
  historyUndoAction,
} from 'containers/Configurator/actions/history';
import {
  navigateShelvesAction,
  removeShelfRequest,
} from 'containers/Configurator/actions/furniture';
import { shelvesSelectionAction } from 'containers/Configurator/actions/selection';

interface Props {
  children?: React.ReactNode;
}

const GlobalShortcutManager = ({ children }: Props) => {
  const dispatch = useDispatch();

  const displayPieceList = () => {
    dispatch(displayPiecesListAction());
  };

  const undoShortcut = () => {
    dispatch(historyUndoAction());
  };

  const redoShortcut = () => {
    dispatch(historyRedoAction());
  };

  const deleteShortCut = () => {
    dispatch(removeShelfRequest());
  };

  const selectAllShortCut = () => {
    dispatch(shelvesSelectionAction([]));
  };

  const navigateUp = () => {
    dispatch(navigateShelvesAction(1));
  };

  const navigateDown = () => {
    dispatch(navigateShelvesAction(-1));
  };

  const handlers = {
    PIECE_LIST: displayPieceList,
    UNDO: undoShortcut,
    REDO: redoShortcut,
    DELETE: deleteShortCut,
    ALL_SELECTION: selectAllShortCut,
    UP_SELECTION: navigateUp,
    DOWN_SELECTION: navigateDown,
  };

  // return <GlobalHotKeys keyMap={keyMap} handlers={handlers} />;
  return (
    <HotKeys keyMap={keyMap} handlers={handlers}>
      {children}
      <GlobalHotKeys keyMap={globalKeyMap} handlers={handlers} />
    </HotKeys>
  );
};

export default GlobalShortcutManager;
